import React from 'react';

import { Box, Paper, Stack, Typography } from '@mui/material';

type Props = {
  titleIcon: JsxNode;
  titleText: string;

  labelIcon: JsxNode;
  labelText: JsxNode;

  caption: JsxNode;

  children: JsxNode;

  actions?: JsxNode;
};
export default function WorkflowCard({
  actions,
  titleIcon,
  titleText,
  labelIcon,
  labelText,
  caption,
  children,
}: Props) {
  const renderActions = () => {
    if (!actions) {
      return null;
    }
    return <Box sx={{ p: 2, borderTop: '1px solid', borderColor: 'divider' }}>{actions}</Box>;
  };
  return (
    <Paper>
      <Box sx={{ p: 2, borderBottom: '1px solid', borderColor: 'divider' }}>
        <Stack spacing={1} direction="row" justifyContent="space-between" alignItems="center">
          <Stack direction="row" spacing={1} alignItems="center" mb={0.5}>
            {titleIcon}
            <Typography variant="h5" component="h2" gutterBottom>
              {titleText}
            </Typography>
          </Stack>

          <Stack direction="row" spacing={1} alignItems="center" color="text.secondary">
            {labelIcon}
            <Typography>{labelText}</Typography>
          </Stack>
        </Stack>
        <Typography variant="body2" color="text.secondary">
          {caption}
        </Typography>
      </Box>
      {children}
      {renderActions()}
    </Paper>
  );
}
